export default __webpack_public_path__ + "static/media/logo.fe51d374.png";